import { render, staticRenderFns } from "./StandappHomeComponent.vue?vue&type=template&id=bdb472fe&"
import script from "./StandappHomeComponent.vue?vue&type=script&lang=js&"
export * from "./StandappHomeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports